import { HistoricalMemCondition, HistoricalMemPurchaseCondition } from './constants';

const attributes = {
  hist_item_type: {
    friendly: 'Item Type',
    validations: {
      maxLength: 150,
    },
  },
  hist_war: {
    friendly: 'War',
    validations: {
      maxLength: 150,
    },
  },
  hist_country: {
    friendly: 'Country',
    validations: {
      maxLength: 150,
    },
  },
  hist_branch: {
    friendly: 'Branch',
    validations: {
      maxLength: 150,
    },
  },
  hist_divison: {
    friendly: 'Divison',
    validations: {
      maxLength: 150,
    },
  },
  hist_period: {
    friendly: 'Period',
    validations: {
      maxLength: 150,
    },
  },
  hist_maker: {
    friendly: 'Maker',
    validations: {
      maxLength: 255,
    },
  },
  hist_edition: {
    friendly: 'Edition',
    validations: {
      maxLength: 255,
    },
  },
  hist_material: {
    friendly: 'Material',
    validations: {
      maxLength: 255,
    },
  },
  hist_named: {
    friendly: 'Named',
    validations: {
      maxLength: 255,
    },
  },
  hist_dimensions: {
    friendly: 'Dimensions',
    validations: {
      maxLength: 150,
    },
  },
  hist_weight: {
    friendly: 'Weight',
    validations: {
      maxLength: 150,
    },
  },
  hist_accessories: {
    friendly: 'Accessories',
    validations: {
      maxLength: 255,
    },
  },
  hist_condition: {
    friendly: 'Condition',
    validations: {
      type: 'enum',
      enumType: HistoricalMemCondition,
    },
  },
  hist_purchase_condition: {
    friendly: 'Purchase Condition',
    validations: {
      type: 'enum',
      enumType: HistoricalMemPurchaseCondition,
    },
  },

};

export default attributes;

export const HistoricalMemDefaultSplitAttribute = 'hist_item_type';

export const HistoricalMemItemSearchAttributes = [];

export const HistoricalMemOverviewAttributes = ['title', 'hist_item_type', 'hist_war', 'hist_country', 'hist_period', 'hist_condition', 'rarity', 'market_value',
  'quantity', 'inventory_no', 'tags',
];

export const HistoricalMemSpecificationAttributes = ['hist_branch', 'hist_divison', 'hist_maker', 'hist_edition', 'hist_material', 'hist_dimensions', 'hist_weight',
  'hist_named', 'hist_accessories',
];

export const HistoricalMemPurchaseAttributes = ['purchase_date', 'purchase_price', 'hist_purchase_condition', 'purchase_contact', 'purchase_notes'];

export const HistoricalMemDetailAttributes = [];

export const HistoricalMemRequiredAttributes = [];

export const HistoricalMemDisplayAttributes = ['hist_item_type', 'hist_war', 'hist_country', 'hist_branch', 'hist_divison', 'hist_period', 'tags'];

export const HistoricalMemSliderGalleryAttributes = {
  titleKey: 'hist_item_type',
  subtitleKey: 'hist_branch',
};



// WEBPACK FOOTER //
// ./src/config/historicalMemorabiliaDataAttributes.js